import { H as Host, g as effect, s as setAttribute } from './vidstack-B11i_cNc.js';
import { P as Poster } from './vidstack-D9mrLNU5.js';
import './vidstack-DMdWO-lC.js';
import './vidstack-BnqIpPdq.js';
import './vidstack-CUVgUi9M.js';
import './vidstack-CG48l7du.js';
import './vidstack-VrKElWm_.js';
import './vidstack-CzvK2UwB.js';
import './vidstack-COCzjeeM.js';
import './vidstack-BSXZsAhp.js';
import './vidstack-DM_McBs5.js';
import './vidstack-ksPACRiU.js';

class MediaPosterElement extends Host(HTMLElement, Poster) {
  constructor() {
    super(...arguments);
    this.Wm = document.createElement("img");
  }
  static {
    this.tagName = "media-poster";
  }
  static {
    this.attrs = {
      crossOrigin: "crossorigin"
    };
  }
  onSetup() {
    this.$state.img.set(this.Wm);
  }
  onConnect() {
    const { src, alt, crossOrigin } = this.$state;
    if (this.Wm.parentNode !== this) {
      this.prepend(this.Wm);
    }
    effect(() => {
      setAttribute(this.Wm, "alt", alt());
      setAttribute(this.Wm, "crossorigin", crossOrigin());
      setAttribute(this.Wm, "src", src() || "");
    });
    effect(() => {
      const { loading, hidden } = this.$state;
      this.Wm.style.display = loading() || hidden() ? "none" : "";
    });
  }
}

export { MediaPosterElement };
